import Swiper from 'swiper/bundle';

var sliderDepoiments = document.querySelector(".slide-depositions-container")
if (sliderDepoiments) {

	new Swiper(sliderDepoiments, {
		slidesPerView: 1,
		spaceBetween: 32,
		centeredSlides: true,
		grabCursor: 'true',


		navigation: {
			nextEl: sliderDepoiments.querySelector(".swiper-button-next"),
			prevEl: sliderDepoiments.querySelector(".swiper-button-prev"),
		},
	});
}
